<template>
    <div class='schoolDetail'>
        <myBanner :imgSrc="imgSrc"/>
        
        <div class="showPc">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/index' }">{{title}}</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/index' }" v-show="!linkId && !searchFlag">{{countryName}}</el-breadcrumb-item>
                <el-breadcrumb-item v-show="!titleQuery" :to="link">院校列表</el-breadcrumb-item>
                <el-breadcrumb-item v-show="titleQuery" :to="{ path: '/linkDetail?id=' + linkId + '&title=' + titleQuery  + '&current=' + current }">{{titleQuery}}</el-breadcrumb-item>
                <el-breadcrumb-item>院校详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="showMobile">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/index' }"><span @click="goIndex">{{title}}</span></el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/index' }" v-show="!searchFlag"><span @click="goIndex2">详情</span></el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/index' }" v-show="!linkId && !searchFlag"><span @click="goIndex2">{{countryName}}</span></el-breadcrumb-item>
                <el-breadcrumb-item v-show="!titleQuery" :to="link">院校列表</el-breadcrumb-item>
                <el-breadcrumb-item v-show="titleQuery" :to="{ path: '/linkDetail?id=' + linkId + '&title=' + titleQuery  + '&current=' + current }">{{titleQuery}}</el-breadcrumb-item>
                <el-breadcrumb-item>院校详情</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="dashed"></div>
        </div>
        <!-- <MyTitle text="院校介绍"/> -->
        <div class="sContent mobileWidthMain">
            <div class="sContImg">
                <img :src="url + info.logo" alt="">
            </div>
            <div class="sContRight">
                <div class="schoolName" @click="goSchool()">{{info.chineseName}}</div>
                <div>{{info.englishName}}</div>
                <div>学历级别：<span v-for="(item,index) in info.levelNames" :key="index">{{item}}{{index === info.levelNames.length - 1 ? "" : "，" }}</span></div>
                <div class="schol">院校性质：{{info.schoolNature}}</div>
                <div>学习方式：<span v-for="(item,index) in info.styleNames" :key="index">{{item}}{{index === info.styleNames.length - 1 ? "" : "/" }}</span> </div>
                <div>位置：{{position}}</div>
            </div>
        </div>
        <!-- 基本情况 -->   
        <div class="baseInfo">
            <div class="baseTitle">{{info.chineseName}}基本情况</div>
            <div class="baseTxt">
                <div>排名：{{info.sort ? info.sort : '暂无数据'}}</div>
                <div>本科生人数：{{info.undergraduateCount ? info.undergraduateCount : 0}}</div>
                <div>国际学生比例：{{info.propOfOverseas ? info.propOfOverseas + '%' : "暂无数据"}}</div>
                <div>成立年份：{{info.foundYear ? info.foundYear : '暂无数据'}}</div>
                <div>研究生人数：{{info.graduateCount ? info.graduateCount : 0}}</div>
                <div>学校分类：{{info.categoryExplain ? info.categoryExplain : '暂无数据'}}</div>
                <div>学生人数：{{info.studentCount ? info.studentCount : 0}}</div>
                <div>师生比：{{info.teacherStudentRatio ? info.teacherStudentRatio : '暂无数据'}}</div>
                <div>认证机构：{{info.certification ? info.certification : '暂无数据'}}</div>
            </div>
        </div>
        <!-- 申请条件 -->
        <div class="baseInfo">
            <div class="baseTitle">{{info.chineseName}}申请条件</div>
            <div class="baseTxt">
                <div v-show="info.ielts">雅思：{{info.ielts}}</div>
                <div v-show="info.tofel">TOFEL：{{info.tofel}}</div>
                <div v-show="info.itep">iTEP：{{info.itep}}</div>
                <div v-show="info.sat">SAT均分：{{info.sat}}</div>
                <div v-show="info.act">ACT：{{info.act}}</div>
                <div v-show="info.gpa">GPA均分：{{info.gpa}}</div>
                <div v-show="info.applyCount">申请人数：{{info.applyCount}}</div>
                <div v-show="info.applyCount">录取率：{{info.applyCount}}%</div>
                <div v-show="info.applyDeadline">申请截止日期：{{applyDeadline}}</div>
                <div v-show="info.semester">学期制度：{{info.semester}}</div>
                <div v-show="info.scholarshipStat">是否提供奖学金：{{info.applyCount == 1 ? '是' : '否'}}</div>
                <div v-show="info.expensesStudy">学费：{{ info.monetary + info.expensesStudy }}</div>
                <div v-show="info.expensesBoard">食宿费：{{ info.monetary + info.expensesBoard }}</div>
                <div v-show="info.expensesApply">院校申请费：{{ info.monetary + info.expensesApply }}</div>
                <div v-show="info.expensesOther">其他杂费：{{ info.monetary + info.expensesOther }}</div>
                <div v-show="info.applicationFee">报名申请费：¥{{info.applicationFee}} </div>
                <div v-show="info.visaFee">获取签证费：¥{{info.visaFee}} </div>
            </div>
        </div>
        <!-- 专业设置 -->
        <div class="baseInfo" v-show="isShowMajor">
            <div class="baseTitle">{{info.chineseName}}专业设置</div>
            <div class="baseTxt">
                <div v-for="(item2,index2) in  info.majorList" :key="index2">{{item2.chineseName + '（' + item2.englishName +'）'}}</div>
            </div>
        </div>
        <!-- 内容 -->
        <div class="contentTitle">{{info.chineseName}}介绍</div>
        <div class="mobileWidthMain newContent" v-html="content"></div>
        <div class="btnContent">
            <div v-show="isShowBtn" class="btnArra">
                <MyButton butTxt="获取offer" class="advise" @btnClick="btnClick" />
                <!-- <MyButton v-show="offerOrderId"  butTxt="获取offer" class="garyBtn" /> -->
                <MyButton v-show="orderList" :butTxt="signName" @btnClick="btnClick2" />
                <MyButton v-show="!orderList" :butTxt="signName" class="garyBtn" />
            </div>
        </div>
        <!-- 培训按钮组 -->
        <div class="trainBtn" v-show="trainBtn.length">
            <MyButton 
                v-for="(itemA,indexA) in trainBtn" 
                :key="indexA"
                :butTxt="itemA.trainingName" 
                :class="{tranActive:indexA == trainIndex}"
                @btnClick="trainBtnClick(indexA,itemA)"/>
        </div>
        <!-- 是否登录弹窗 -->
        <el-dialog
        title="提示"
        :visible.sync="loginVisible"
        :width="dialogWidth"
        center>
            <div class="loginTxt">{{dialogTxt}}</div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" type="primary" @click="goLogin()">确 定</el-button>
                <el-button size="medium" @click="loginVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { getDataMixin } from "common/mixin.js"
    import { getSchoolDetail, addTrainOrder } from "network/home.js"
    import { checkRealName } from "network/application.js"
    export default {
        name:"schoolDetail",
        mixins:[getDataMixin],
        data(){
            return {
                imgSrc:[],
                title:'',
                isShowBtn:false,
                content:"",
                signName:"",
                info:"",
                url:process.env.VUE_APP_WEB_URL,
                isShowMajor:false,
                applyDeadline:"",
                loginVisible:false,
                dialogTxt:'',
                isRealName:false,
                offerOrderId:"",
                visaOrderId:'',
                orderList:[],
                dialogWidth:'20%',
                levelIds:'',
                countryId:'',
                flag:'login',
                trainBtn:[],
                trainIndex:5,
                trainingId:''
            }
        },
        created(){
            this.getData()
            localStorage.setItem('schoolListLink',JSON.stringify(this.link))
            this.getCheckRealName()
             if(this.$IsMobile()){
                this.dialogWidth = '80%'
            }
        },
        mounted(){
            sessionStorage.setItem('current',this.current)
        },
        methods:{
            // 查真实姓名及手机号是否填写
            getCheckRealName(){
                checkRealName().then(res=>{
                    if(res.code == 1){
                        this.isRealName = true
                    }else if(res.code == 5){
                        this.isRealName = false
                        this.dialogTxt = "登录后可以进行报名咨询"
                    }else{
                        this.isRealName = false
                        this.dialogTxt = "请先完善个人信息"
                    }
                })
            },
            getData(){
                this.navData = this.getNvData[this.getNavIndex - 1]
                if(this.navData){   
                    let bannerData = this.navData.themeBanners
                    if(bannerData.length && bannerData.length == 2){
                        for(let i in bannerData){
                            bannerData.push(bannerData[i])
                        }
                        this.imgSrc = bannerData
                    }else if(bannerData.length){
                        this.imgSrc = bannerData
                    }
                    this.title = this.navData.title
                    if(this.navData.title == "合作院校"){
                        this.isShowBtn = false
                    }else{
                        this.isShowBtn = true
                        this.signName = "获取签证"
                    }
                    this.getSchoolDetailData({
                        schoolId:this.id,
                        orderId:''
                    })
                }
            },
            getSchoolDetailData(data){
                getSchoolDetail(data).then(res=>{
                    // this.levelIds = res.data.levelIds[0]
                    this.levelIds = res.data.levelIds
                    this.content = res.data.content
                    this.info = res.data
                    this.isShowMajor = this.info.majorList.length
                    let aa = this.info.applyDeadline
                    if(aa){
                        this.applyDeadline = aa.slice(0,10)
                    }
                   this.orderList = res.data.orderList
                   this.countryId = res.data.countryId
                   this.trainBtn = res.data.trainingList
                })
            },
            addTrainOrderData(data){
                addTrainOrder(data).then(res=>{
                    if(res.code == 1){
                        this.$router.push('/trainOrderDetail?id=' + res.data)
                    }
                })
            },
            // 事件--------
            goLogin(){
                let lastLink = window.location.href;
                sessionStorage.setItem('lastLink',lastLink)
                this.loginVisible = false
                if(this.flag == 'login'){
                    if(!this.isLogin){
                        this.$router.push('/login')
                    }else if(!this.isRealName){
                        this.$router.push('/profile')
                    }
                }else if(this.flag == "train"){
                    this.addTrainOrderData({
                        schoolId:this.id,
                        trainingId:this.trainingId
                    })
                }
                
            },
            btnClick(){
                if(this.isLogin && this.isRealName){
                    //用于判断是不是链接进入（直通车。。）
                    if(this.linkId){
                        this.$router.push({
                            path:'/application',
                            query:{
                                id:this.id,
                                countryId:this.countryId,
                                linkId:this.linkId,
                                title:this.titleQuery,
                                current:this.current
                            }
                        })
                    }else{
                        this.$router.push({
                            path:'/application',
                            query:{
                                id:this.id,
                                countryId:this.countryId
                            }
                        })
                    }
                }else {
                    this.flag = 'login'
                    if(!this.isLogin){
                        this.dialogTxt = "登录后可以进行报名咨询"
                        this.loginVisible = true
                    }else if(!this.isRealName){
                        this.loginVisible = true
                    }
                }
                
            },
            btnClick2(){
                if(this.orderList.length >= 2){
                    let flag = false
                    for(let i in this.orderList){
                        if(this.orderList[i].visaOrder != null){
                            flag = true
                        }
                    }
                    if(flag){
                        this.$router.push('/myOrder')
                    }else{
                        this.$message({
                            type:'error',
                            message:"签证订单尚未生成"
                        })
                    }
                }else{
                    let visaOrderId = this.orderList[0].visaOrder
                    if(visaOrderId){
                        this.$router.push('/orderDetail?id=' + visaOrderId.id)
                    }else{
                        this.$message({
                            type:'error',
                            message:"签证订单尚未生成"
                        })
                    }
                }
            },
            goIndex(){
                this.$store.state.mShowControlMeue = true
            },
            goIndex2(){
                this.$store.state.mShowControlMeue = false
            },
            //学校跳转
            goSchool(){
                if(this.info.website){
                    window.open(this.info.website)
                }
            },
            // 培训按钮组
            trainBtnClick(index,item){
                this.trainIndex = index
                this.loginVisible = true
                if(this.isLogin && this.isRealName){
                    this.flag = 'train'
                    this.trainingId = item.id
                    this.dialogTxt = "确认报名" + item.trainingName + '？'
                }else{
                    this.flag = 'login'
                    if(!this.isLogin){
                        this.dialogTxt = "登录后可以进行报名咨询"
                    }
                }
                
            }
        },
        computed:{
            isLogin(){
                return this.$store.state.isLogin
            },
            // isRealName(){
            //     return this.$store.state.isRealName
            // },
            id(){
               return this.$route.query.id ? this.$route.query.id : "" 
            },
            current(){
                return this.$route.query.current ? this.$route.query.current : 1 
            },
            mode(){
                return this.$route.query.mode ? this.$route.query.mode : "" 
            },
            modeIndex(){
                return this.$route.query.modeIndex ? this.$route.query.modeIndex : 0 
            },
            provinceId(){
                return this.$route.query.provinceId ? this.$route.query.provinceId : "" 
            },
            provinceIndex(){
                return this.$route.query.provinceIndex ? this.$route.query.provinceIndex : 0 
            },
            titleQuery(){
                return this.$route.query.title ? this.$route.query.title : '' 
            },
            linkId(){
                return this.$route.query.linkId ? this.$route.query.linkId : '' 
            },
            countryName(){
                return sessionStorage.getItem('countryName') ? sessionStorage.getItem('countryName') : '暂无'
            },
            link(){
                if(this.searchFlag){
                    return { path:'/schoolList??keyword='+ this.getKeyword +'&flag=search' + '&current=' + this.current}
                }else{
                    return { path: '/schoolList?current=' + this.current + '&mode=' + this.mode + '&modeIndex=' + this.modeIndex + '&provinceId=' + this.provinceId + '&provinceIndex=' + this.provinceIndex  }
                }
                
            },
            position(){
                return (this.info.provinceName ? this.info.provinceName : '' ) + ' ' + (this.info.city ? this.info.city : '')  + ' ' + (this.info.position ? this.info.position : '' ) 
            },
            searchFlag(){
                return this.$route.query.flag ? this.$route.query.flag : ""
            },
            getKeyword(){
                return this.$route.query.keyword ? this.$route.query.keyword : "" 
            },
        }
    }
</script>
<style scoped lang="scss">
.newContent{
    border:1px solid rgba(229, 229, 229, 1);
    border-top:0;
}
.loginTxt{
    text-align: center;
    font-size: 16px;
}
.btnContent{
    padding: 40px 80px;
    .btnArra{
        display: flex;
    }
}
.advise{
    background:#e6963e;
}
.garyBtn{
    background: rgba(215, 215, 215, 1);
    cursor: not-allowed;
}
.trainBtn{
    display: flex;
    margin-bottom:40px;
    padding:0 80px;
    .tranActive{
        background:#e6963e;
    }
}
.sContent{
    border:1px solid rgba(229, 229, 229, 1);
    margin:30px 0 20px;
    background:#fff;
    display: flex;
    .sContImg{
        img{
            // height: 168px;
            width:180px;
        }
    }
    div.schoolName{
        text-decoration:underline;  
        cursor: pointer;
        margin-bottom:5px;
    }
    .sContRight{
        color:#606266;
        margin-left:50px;
        line-height: 28px;
        font-size:14px;
        div:nth-child(1),div:nth-child(2),div.schol span{
            color:var(--color-main);
        }
        div:nth-child(1){
            font-size:26px;
        }
        div:nth-child(2){
            font-size:22px;
        }
    }
}
// 基本详情
.baseInfo{
    border:1px solid rgba(229, 229, 229, 1);
    color:#606266;
    margin-bottom:20px;
    .baseTitle{
        color:var(--color-main);
        padding:15px 30px 0;
        font-size:20px;
    }
    .baseTxt{
        padding:10px 30px;
        overflow: hidden;
        div{
            width:33%;
            float: left;
            margin:10px 0;
        }
    }
}
.contentTitle{
    border:1px solid rgba(229, 229, 229, 1);
    border-bottom:0;
    color:var(--color-main);
    padding:10px 30px;
    font-size:20px;
}
@media screen and (max-width: 768px){
    .btnContent{
        padding: 0.4rem 0.1rem;
        .btnArra{
            justify-content: space-around;
        }
    }
    .loginTxt{
        font-size: .3rem;
    }
    .trainBtn{
        margin-bottom:0.6rem;
        padding:0 0.1rem;
        .tranActive{
            background:#e6963e;
        }
    }   
    .btnContent .comButton,.trainBtn .comButton{
        width: 30%;
    }
    .sContent{
        margin:0.3rem auto 0.2rem;
        .sContImg{
            img{
                // height:1.7rem;
                width:2.5rem;
            }
        }
        .sContRight{
            margin-left:0.3rem;
            line-height: 0.4rem;
            font-size:0.24rem;
            div:nth-child(1){
                font-size:0.36rem;
            }
            div:nth-child(2){
                font-size:0.3rem;
            }
        }
    }
    // 基本详情
    .baseInfo{
        width:90%;
        margin:0 auto 0.3rem;
        .baseTitle{
            padding:0.2rem 0.4rem 0;
            font-size:0.36rem;
        }
        .baseTxt{
            padding:0.2rem 0.4rem;
            div{
                width:100%;
                margin:0.15rem 0;
                font-size:0.28rem;
            }
        }
    }
    .contentTitle{
        width:90%;
        margin:0 auto;
        padding:0.2rem 0.4rem;
        font-size:0.36rem;
    }
}
</style>